import type { StyleRule } from '@archipro-design/aria';
import { pxArrayToRem, pxToRem } from '@archipro-design/aria';

export const CloseDialog: StyleRule = () => ({
    cursor: 'pointer',
});

export const DownloadMessage: StyleRule = ({ theme }) => ({
    fontSize: pxToRem(18),
    marginBottom: pxToRem(51),
    maxWidth: pxToRem(360),
    textAlign: 'center',
    [theme.screen.min.tablet]: {
        fontSize: pxToRem(22),
        marginBottom: pxToRem(56),
        maxWidth: pxToRem(655),
        textAlign: 'left',
    },
});

export const DontAskAgain: StyleRule = () => ({
    marginLeft: pxToRem(13),
});

export const DownloadButton: StyleRule = ({ theme }) => ({
    marginTop: pxToRem(50),
    padding: pxArrayToRem([15, 135]),
    '& div': {
        fontFamily: theme.siteVariables.fontFamilyGTAmerica,
    },
    [theme.screen.min.tablet]: {
        marginTop: 0,
        padding: pxArrayToRem([28, 59]),
    },
});

export const DownloadDrawer: StyleRule = () => ({
    height: `${pxToRem(150)} !important`,
});

export const DrawerTitle: StyleRule = () => ({
    marginBottom: pxToRem(37),
});
